import * as React from 'react';
import { Form } from 'react-bootstrap';

type OwnProps = {
    value: string;
    errorMsg: string;
};

export type DispatchProps = {
    onChange: (e: any) => void;
};

type OwnState = {};

type Props = DispatchProps & OwnProps;

export default class EupatiEmailbox extends React.Component<Props, OwnState> {

    render() {
        return (
            <>
                <Form.Group>
                    <Form.Control
                        type='email'
                        value={this.props.value}
                        className="eupati-textbox"
                        placeholder="Please type email"
                        onChange={(e) => this.props.onChange(e)}
                    />
                    {!!this.props.errorMsg &&
                        <span className='text-danger'>{this.props.errorMsg}</span>
                    }
                </Form.Group>
            </>
        );
    }
}
